/**
 * Ecoclean's ticket types
 */
export default [
  {
    key: 'device_breakdown',
    value: 'Device breakdown',
    icon: 'alert-triangle',
    deviceInput: true,
    deviceIdentify: true,
  },
  {
    key: 'technical_issue',
    value: 'Technical issue',
    icon: 'alert-square',
    deviceInput: true,
    deviceIdentify: true,
  },
  {
    key: 'clarification_spare_parts',
    value: 'Spare part',
    icon: 'part',
    deviceInput: true,
    deviceIdentify: true,
  },
  {
    key: 'training',
    value: 'Training',
    icon: 'graduation-hat',
    deviceInput: true,
    deviceIdentify: true,
  },
  {
    key: 'other',
    value: 'Other',
    icon: 'dots-horizontal',
    deviceInput: false,
  },
]
